import { collection, doc } from "firebase/firestore";
import db from "./firebaseConfig";
import { Collections } from "../utils/Constants";

export const getPropertyRef = (id) => doc(db, Collections.properties, id);
export const getPropertyCollectionRef = () =>
  collection(db, Collections.properties);

export const getWidgetRef = (ref, id) => doc(ref, Collections.widgets, id);
export const getWidgetCollectionRef = () => collection(db, Collections.widgets);

export const getVisitorRef = (id) => doc(db, Collections.visitors, id);
export const getVisitorCollectionRef = () =>
  collection(db, Collections.visitors);

export const getSessionRef = (ref, id) => doc(ref, Collections.sessions, id);
export const getSessionCollectionRef = (ref) =>
  collection(ref, Collections.sessions);

export const getActivitiesRef = (ref, id) =>
  doc(ref, Collections.activities, id);
export const getActivitiesCollectionRef = (ref) =>
  collection(ref, Collections.activities);

export const getFeedbackRef = (id) => doc(db, Collections.feedbacks, id);
export const getFeedbackCollectionRef = () =>
  collection(db, Collections.feedbacks);

export const getTokenRef = (id) => doc(db, Collections.deviceTokens, id);
export const getTokenCollectionRef = () =>
  collection(db, Collections.deviceTokens);

export const getBanListRef = (id) => doc(db, Collections.banList, id);
export const getBanListCollectionRef = () =>
  collection(db, Collections.banList);

export const getHistoriesRef = (id) => doc(db, Collections.histories, id);

// Contact List
export const getContactsCollection = () => collection(db, Collections.contacts);
export const getContactRef = (id) => doc(db, Collections.contacts, id);

export const getHistoriesCollectionRef = () =>
  collection(db, Collections.histories);
// Triggers
export const getTriggersCollection = () => collection(db, Collections.triggers);

// Workflows
export const getWorkflowCollection = () =>
  collection(db, Collections.workflows);

export const getWorkflowRef = (workflowId) =>
  doc(db, Collections.workflows, workflowId);
